
function initServiceCardComponent(app) {
    app.component('service-card', {
        template: '#service-card',
        props: {
            icon: {
                type: String,
                required: true,
            },
            title: {
                type: String,
                required: true,
            },
            contentText: {
                type: String,
                required: true,
            },
            actionButtonId: {
                type: String,
                required: true,
            },
            isPreselectedCard: {
                type: Boolean,
                required: false,
            },
        },
        emits: ['selectServiceType'],
        data() {
            return {
                isSelected: false,
            };
        },
        computed: {
            isActive() {
                return this.isPreselectedCard ? this.isPreselectedCard : this.isSelected;
            },
        },
        methods: {
            onActionClick() {
                this.$emit('selectServiceType');
            },
        },
    });
}

export default initServiceCardComponent;
